// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LBB_","rootNoMargin":"styles_rootNoMargin__3lmEz"};